<template>
    <router-view/>
</template>
<script>
  import Vue from 'vue'
  import i18n from './i18n/i18n'
  import store from './vuex/store'
  export default {
    mounted() {
      window.document.title = this.$t('tajik_securities')
      this.$nextTick(()=>{
          // 加载完html后加载js
          let index = document.createElement("script");
          index.src = "../js/2020_swiper.jquery.min.js";
          let index_s = document.getElementsByTagName("script")[0];
          index_s.parentNode.insertBefore(index, index_s);

          let jq = document.createElement("script");
          jq.src = "../js/jquery-1.11.0.min.js";
          let jq_s = document.getElementsByTagName("script")[0];
          jq_s.parentNode.insertBefore(jq, jq_s);
      })
    },
    methods: {
      setLocale() {
        if (this.$route.query.lang) {
          localStorage.setItem("lang", this.$route.query.lang)
          Vue.setStorageVariable({ lang: this.$route.query.lang })
          let query = Object.assign({}, this.$route.query);
          delete query.lang;
          this.$router.replace({ query });
        }
        let lang = this.currentLang || 'zh'
        i18n.locale = lang
      },
    },
    created(){
      store.dispatch('SET_GLOBAL_VARIABLE')
      store.dispatch('SET_STORAGE_VARIABLE')
      this.setLocale()
    }
  }
</script>

